import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { patientName } from 'Data/format.js'

export function useOnClick(props) {
  let person = useDataValue({
    context: 'person',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick(event) {
    event.stopPropagation()
    submit({
      type: 'tabs/add',
      tab: {
        id: person.patient._id,
        type: 'Patient',
        name: patientName(person),
        tab: 'profile',
        viewPath: '/App/Account/Content/Patients',
        patient_id: person.patient._id,
      },
    })

    setFlowTo(normalizePath(props.viewPath, '../../../../../../../No'))
  }
}
